import { getColorsByType, type PreviewCardType } from './helpers/getColorsByType'

import type { PreviewCardProps } from './types'

import * as S from './styles'

export const PreviewCard = ({
  label,
  value,
  icon,
  infoIcon,
  gpValue,
  gmPercentage,
  previewType = 'budget',
  isNegative = false
}: PreviewCardProps) => {
  return (
    <S.Container
      style={{
        borderTopColor: getColorsByType(previewType as PreviewCardType, isNegative)?.background
      }}
    >
      <S.LeftBox>
        <S.Label>
          {label}
          {!!infoIcon && infoIcon}
        </S.Label>

        <S.PercentageValue
          style={{
            color: getColorsByType(previewType as PreviewCardType, isNegative)?.text
          }}
        >
          {value}
        </S.PercentageValue>

        <S.BottomBox>
          <S.BottomText
            style={{
              color: getColorsByType(previewType as PreviewCardType, isNegative)?.text
            }}
          >{`GP: ${gpValue}`}</S.BottomText>
          <S.BottomText
            style={{
              color: getColorsByType(previewType as PreviewCardType, isNegative)?.text
            }}
          >{`GM: ${gmPercentage}`}</S.BottomText>
        </S.BottomBox>
      </S.LeftBox>

      <S.IconBox
        style={{
          color: getColorsByType(previewType as PreviewCardType, isNegative)?.color,
          background: getColorsByType(previewType as PreviewCardType, isNegative)?.background
        }}
      >
        {icon}
      </S.IconBox>
    </S.Container>
  )
}
